import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AccordionDetails, AccordionSummary } from '@mui/material'
import React, { ReactNode } from 'react'
import { AccordionStyled } from './styles'

export interface AccordionProps {
  summaryContent?: ReactNode
  children?: ReactNode
  height?: number
  width?: string
  defaultExpanded?: boolean
}

export const Accordion: React.FC<AccordionProps> = ({
  summaryContent,
  defaultExpanded = true,
  children,
  height = 80,
  width = '100%'
}) => {
  return (
    <AccordionStyled width={width} height={height} defaultExpanded={defaultExpanded}>
      <AccordionSummary
        data-testid="summary"
        id="AccordionTitle"
        expandIcon={<ExpandMoreIcon data-testid="expand-icon" />}
      >
        {summaryContent}
      </AccordionSummary>
      <AccordionDetails data-testid="details">{children}</AccordionDetails>
    </AccordionStyled>
  )
}
